import { render, staticRenderFns } from "./RoundAlert.vue?vue&type=template&id=2c237aae"
import script from "./RoundAlert.vue?vue&type=script&lang=ts"
export * from "./RoundAlert.vue?vue&type=script&lang=ts"
import style0 from "./RoundAlert.vue?vue&type=style&index=0&id=2c237aae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports